{
  "name": "@postdata/cli",
  "version": "0.12.0",
  "description": "A CLI to run Postdata test scripts in CI environments.",
  "homepage": "https://postdata.cn",
  "type": "module",
  "main": "dist/index.js",
  "bin": {
    "hopp": "bin/post.js"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "build": "pnpm exec tsup",
    "dev": "pnpm exec tsup --watch",
    "debugger": "node debugger.js 9999",
    "prepublish": "pnpm exec tsup",
    "prettier-format": "prettier --config .prettierrc 'src/**/*.ts' --write",
    "test": "pnpm run build && vitest run",
    "do-typecheck": "pnpm exec tsc --noEmit",
    "do-test": "pnpm run test"
  },
  "keywords": [
    "cli",
    "postdata",
    "post-cli"
  ],
  "author": "Postdata (support@mamahuhu.io)",
  "repository": {
    "type": "git",
    "url": "https://github.com/mamahuhu-io/postdata.git"
  },
  "bugs": {
    "url": "https://github.com/mamahuhu-io/postdata/issues",
    "email": "support@mamahuhu.io"
  },
  "license": "MIT",
  "private": false,
  "dependencies": {
    "aws4fetch": "1.0.20",
    "axios": "1.7.7",
    "chalk": "5.3.0",
    "commander": "12.1.0",
    "isolated-vm": "5.0.1",
    "js-md5": "0.8.3",
    "lodash-es": "4.17.21",
    "qs": "6.13.0",
    "verzod": "0.2.3",
    "xmlbuilder2": "3.1.1",
    "zod": "3.23.8"
  },
  "devDependencies": {
    "@hoppscotch/data": "workspace:^",
    "@hoppscotch/js-sandbox": "workspace:^",
    "@relmify/jest-fp-ts": "2.1.1",
    "@types/lodash-es": "4.17.12",
    "@types/qs": "6.9.16",
    "fp-ts": "2.16.9",
    "prettier": "3.3.3",
    "qs": "6.11.2",
    "tsup": "8.3.0",
    "typescript": "5.6.3",
    "vitest": "2.1.2"
  }
}
